export default __webpack_public_path__ + "static/media/location.93a72a75.svg";